module.exports = __webpack_public_path__ + "img/phone.ff078fac.svg";